// Select all navigation buttons and images safely
const carouselTabs = document.querySelectorAll('.featured-collections-navigation button') || [];
const carouselImages = document.querySelectorAll('.ft-coll-img') || [];

// Only proceed if we have buttons
if (carouselTabs.length > 0) {
  carouselTabs.forEach((button, index) => {
    button?.addEventListener('click', () => {
      // Update buttons aria-current safely
      carouselTabs.forEach((btn, i) => {
        btn?.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      // Update images aria-current safely
      carouselImages.forEach((img, i) => {
        img?.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    });
  });
}
